import { AuthTypes } from 'enums';
import isEmpty from 'lodash/isEmpty';

export default function isContentLocked({ streams = [] }, userAuth, preauthorizedResources = []) {
    if (isEmpty(streams) || isEmpty(userAuth) || isEmpty(preauthorizedResources)) {
        return false;
    }

    const isLocked = (
        userAuth.indexOf(AuthTypes.MVPD) > -1 &&
        streams.some(({ authTypes = [], adobeRSS = '', adobeResource: adobeResourceArg }) => {
            let adobeResource = adobeResourceArg;
            if (!adobeResource) {
                const result = /<title>([^<]+)<\/title>/.exec(adobeRSS);
                if (result && result[1]) {
                    adobeResource = result[1];
                }
            }
            return (
                adobeResource &&
                authTypes.indexOf(AuthTypes.MVPD) > -1 &&
                preauthorizedResources.indexOf(adobeResource) === -1
            );
        })
    );

    return isLocked;
}



// WEBPACK FOOTER //
// ./app/lib/auth/isContentLocked.js